export default __webpack_public_path__ + "static/media/Harness of Erlik.01377b47.jpg";